import { render, staticRenderFns } from "./Textpicker.vue?vue&type=template&id=7f618f8a&"
import script from "./Textpicker.vue?vue&type=script&lang=js&"
export * from "./Textpicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports